import React from 'react';
import { Link } from 'react-router-dom';
import { HARDWARE_SKUS } from '../data/products';
import PageWorld from '../components/site/PageWorld';
import { STORE } from '../data/worlds';

// Hardware catalog (/store). The homepage sells agentOS; this page is the
// attach surface: every SKU ships with Nventr OS preloaded and links back to
//           the runtime. Host/operator economics live on /partners.

export default function Store() {
  return (
    <PageWorld world={STORE}>
    <div className="cs-store">
      <header className="cs-store-hero">
        <h1>Hardware that ships with the OS</h1>
        <p>
          Optional devices and nodes so agents and private models have
          somewhere to run. Every unit ships with nventr OS preloaded — trial
          included, runtime plan after. The business is the runtime, not the
          box: see <Link to="/pricing">Platform and Kit pricing</Link>.
        </p>
        <div className="cs-land-cta-row cs-land-cta-center">
          <Link to="/pricing" className="cs-btn cs-btn-primary">
            See pricing
          </Link>
          <Link to="/partners" className="cs-btn cs-btn-outline">
            Hosting &amp; partner economics
          </Link>
        </div>
      </header>

      <section className="cs-store-section">
        <div className="cs-store-grid">
          {HARDWARE_SKUS.map((p) => (
            <article key={p.sku} className="cs-product">
              <div className="cs-product-img">
                <img src={p.image} alt={`${p.sku} — ${p.name}`} loading="lazy" />
              </div>
              <div className="cs-product-body">
                <div className="cs-product-sku">{p.sku}</div>
                <h3>{p.name}</h3>
                <p className="cs-product-tagline">{p.tagline}</p>
                <p className="cs-product-desc">{p.description}</p>
                <ul className="cs-product-specs">
                  {p.specs.map((s) => (
                    <li key={s}>{s}</li>
                  ))}
                </ul>
                <div className="cs-product-price">
                  <span>{p.price}</span>
                  <small>{p.priceNote}</small>
                  {p.earningsNote && (
                    <Link to="/partners#earnings" className="cs-product-earnings">
                      {p.earningsNote}
                    </Link>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <footer className="cs-store-footer">
        Product images are planning renders; final industrial design TBD with
        OEM partners. Pricing bands are directional, pre-pilot. OS preloaded —
        runtime is the product: <Link to="/#pricing">agentOS pricing</Link>.
      </footer>
    </div>
    </PageWorld>
  );
}
